function setWrapMargin(){
	if($('.wrap')[0].getAttribute('data-category') == 'top'){
		$('.wrap').removeAttr('style');
	}else{
		var n = $(window).height()*.8;
		$('.wrap').css('margin-bottom', n);
	}
}

module.exports = setWrapMargin;



// WEBPACK FOOTER //
// ./es2015/module/_wrap_margin.js